import { render, staticRenderFns } from "./UpcomingsConsultations.vue?vue&type=template&id=b29a65e2"
import script from "./UpcomingsConsultations.vue?vue&type=script&lang=js"
export * from "./UpcomingsConsultations.vue?vue&type=script&lang=js"
import style0 from "./UpcomingsConsultations.vue?vue&type=style&index=0&id=b29a65e2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports